import { Component } from '@angular/core';

@Component({
  selector: 'app-landing-contact-us',
  templateUrl: './landing-contact-us.component.html',
  styleUrls: ['../landing/landing.component.scss', './landing-contact-us.component.scss']
})
export class LandingContactUsComponent {

}
